module.exports = __webpack_public_path__ + "img/digitHero.34fd8a10.png";